import {JsonPlatformRestaurantAvailability} from '@deliveryhero/vendor-growth-api-client';
import {AvailabilityStateSlice} from '../slices/AvailabilityStateSlice';

function findMatchingAvailability(
  availabilities: JsonPlatformRestaurantAvailability[],
  platformKey?: string,
  platformRestaurantId?: string,
): undefined | JsonPlatformRestaurantAvailability {
  if (availabilities.length === 0) {
    return undefined;
  }

  const matchingAvailability: undefined | JsonPlatformRestaurantAvailability = availabilities.find(
    (availability: JsonPlatformRestaurantAvailability): boolean =>
      availability.platformKey === platformKey &&
      availability.platformRestaurantId === platformRestaurantId,
  );

  return matchingAvailability;
}

function applyAvailabilitiesUpdate(
  state: AvailabilityStateSlice,
  updatedAvailabilities: JsonPlatformRestaurantAvailability[],
): JsonPlatformRestaurantAvailability[] | undefined {
  const latestAvailabilities: JsonPlatformRestaurantAvailability[] | undefined =
    state.availabilities;

  if (latestAvailabilities === undefined) {
    return latestAvailabilities;
  }

  updatedAvailabilities.forEach((updatedAvailability: JsonPlatformRestaurantAvailability) => {
    const matchingAvailability: undefined | JsonPlatformRestaurantAvailability =
      findMatchingAvailability(
        latestAvailabilities,
        updatedAvailability.platformKey,
        updatedAvailability.platformRestaurantId,
      );

    if (matchingAvailability !== undefined) {
      const availabilityToReplaceIndex: number = latestAvailabilities.indexOf(matchingAvailability);
      latestAvailabilities.splice(availabilityToReplaceIndex, 1, updatedAvailability);
    }
  });

  return latestAvailabilities;
}

export const availabilitiesUpdated = (
  state: AvailabilityStateSlice,
  {
    payload,
  }: {
    payload: {
      availabilities: JsonPlatformRestaurantAvailability[] | undefined;
    };
  },
): void => {
  if (payload.availabilities === undefined) {
    return;
  }
  const updatedAvailabilities = applyAvailabilitiesUpdate(state, payload.availabilities);
  state.availabilities = updatedAvailabilities;

  // Restart polling only if availabilities are updated by the backend and received in the payload
  if (payload.availabilities.length > 0) {
    state.restartPollingTimestamp = Date.now();
  }
};
